import styled from 'styled-components';

const DesignStyle = styled.div`
	--designContMarginV: calc(var(--designImageMaxWidth) * 0.12);
	--designImageMaxWidth: var(--sp144x);
	--designImagePaddingTop: var(--sp83x);
	--designTextMargin: var(--sp48x) 0;
	--textMaxWidth: var(--sp200x);
	--textPaddingTop: var(--sp11x);

	overflow: hidden;

	.design {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: var(--designContMarginV);
		margin-bottom: var(--designContMarginV);

		.image-parent-cont {
			position: relative;
			max-width: var(--designImageMaxWidth);
			width: 100%;
			z-index: 2;
			/* transform:  rotate(5deg); */
			overflow: hidden;

			.design-image {
				max-width: var(--designImageMaxWidth);
				width: 100%;
				padding-top: var(--designImagePaddingTop);
				position: relative;
				z-index: 2;

				img {
					border-radius: var(--sp2x);
				}
			}

			.marquee-cont {
				z-index: 2;
				transform: translate(-50%, -50%) rotate(-5deg);

				.marquee-inner-cont {
					max-width: 100vw;
					width: 100vw;
					display: flex;
					white-space: nowrap;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					/* transform:  rotate(-5deg); */
				}
			}
		}

		.colored-board {
			width: var(--designImageMaxWidth);
			padding-top: var(--designImagePaddingTop);
			position: absolute;
			top: 50%;
			left: 51%;
			/* transform: translate(-50%, -50%) rotate(15deg); */
			z-index: 1;
			border-radius: var(--sp2x);
		}

		.marquee-cont {
			max-width: 100vw;
			width: 100vw;
			display: flex;
			white-space: nowrap;
			position: absolute;
			top: 50%;
			left: 50%;
			/* transform: translate(-50%, -50%); */
			user-select: none;

			.design-text {
				position: relative;
				display: inline-block;
				padding-right: var(--sp3x);
				margin: var(--designTextMargin);
				white-space: nowrap;
				text-transform: uppercase;
				z-index: 3;

				.space {
					padding: 0 1.5rem;
				}
			}
		}
	}

	.text {
		margin: 0 auto;
		padding-top: var(--textPaddingTop);
		max-width: var(--textMaxWidth);
		text-align: center;
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--designTextMargin: var(--sp36x) 0;
		--designImageMaxWidth: var(--sp108x);
		--designImagePaddingTop: var(--sp62x);
		--textMaxWidth: var(--sp170x);
		--textPaddingTop: var(--sp9x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--designTextMargin: var(--sp28x) 0;
		--designImageMaxWidth: var(--sp88x);
		--designImagePaddingTop: var(--sp49x);
		--textMaxWidth: var(--sp130x);
		--textPaddingTop: var(--sp8x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--designTextMargin: var(--sp28x) 0;
		--designImageMaxWidth: var(--sp84x);
		--designImagePaddingTop: var(--sp49x);
		--textMaxWidth: var(--sp124x);
		--textPaddingTop: var(--sp8x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--designTextMargin: var(--sp25x) 0;
		--designImageMaxWidth: var(--sp75x);
		--designImagePaddingTop: var(--sp43x);
		--textMaxWidth: var(--sp100x);
		--textPaddingTop: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--designTextMargin: var(--sp22x) 0;
		--designImageMaxWidth: var(--sp65x);
		--designImagePaddingTop: var(--sp38x);
		--textMaxWidth: var(--sp84x);
		--textPaddingTop: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--designTextMargin: var(--sp22x) 0;
		--designImageMaxWidth: var(--sp65x);
		--designImagePaddingTop: var(--sp38x);
		--textMaxWidth: var(--sp80x);
		--textPaddingTop: var(--sp5x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--designTextMargin: var(--sp22x) 0;
		--designImageMaxWidth: var(--sp45x);
		--designImagePaddingTop: var(--sp28x);
		--textMaxWidth: var(--sp45x);
		--textPaddingTop: var(--sp5x);

		.section {
			margin-bottom: calc(var(--contMarginV) / 2) !important;
		}
	}
`;

export default DesignStyle;
